/**
 * Supported asset constants
 */
export const ASSETS = ['USDT', 'USDC', 'ETH'];

export const STABLECOINS = ['USDT', 'USDC'];
